import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriEditComponent.vue?vue&type=template&id=5ca66201"
import script from "./RsaConfigurazioneLaboratoriEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports